/* eslint-disable */

export default {
  status: 200,
  data: {
    status: true,
    data: {
      images: {
        background: [],
        cover_page: [
          {
            url_image:
              "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1300x1738/Eiffel tower Spring - Thinkstock STOCK use by Insight Vacations only.jpeg"
          }
        ],
        cover_video: [],
        images_page: [
          {
            url_image:
              "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1360x822/restaurant-985650.jpg"
          },
          {
            url_image:
              "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1360x822/Sacre-Coeur.jpg"
          },
          {
            url_image:
              "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1360x822/cheese-1772829.jpg"
          },
          {
            url_image:
              "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1360x822/arc-de-triomphe-101633.jpg"
          }
        ]
      },
      itineraries: [
        {
          days: [
            {
              meals: [
                {
                  mealsday: "Welcome Reception"
                }
              ],
              title: "Arrive Paris (7 Nights)",
              textday: [
                {
                  textday:
                    "Paris is yours to explore on this in-depth City Explorer. Check in to your centrally located hotel and spend the afternoon getting to know your surrounds. Wander through the leafy boulevards and winding lanes of the French capital, stopping for a leisurely café au lait while watching sophisticated Parisians go by. This evening, join your fellow travellers and Travel Director for a quintessentially Parisian Welcome Reception."
                }
              ],
              duration: 1,
              idimagen: 10157,
              startday: 1,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "Le Méridien Etoile",
              line_breaks_number: 0,
              startdate: "2022-09-18",
              enddate: "2022-09-19",
              url_image:
                "",
              url_image_1200_725:
                "",
              url_image_1600_900:
                "",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Paris Sightseeing and At Leisure day1",
              textday: [
                {
                  textday:
                    "<p>Join your Travel Director this morning for a tour of this mesmerising city. View the grand Champs-Élysées, Place de la Concorde and Arc de Triomphe, built by Napoleon in the 19th century. Delve into its hidden squares and secret passages, visiting one of Paris's most historic neighbourhoods and a favourite local haunt that remains a secret to outsiders. Next, you’ll Dive Into Culture at Fragonard Parfumerie for a visit with a certified ‘nose' who will guide you in the creation of your own unique fragrance. Later, you’ll experience a true Parisian highlight. Ascend to the second level of the Eiffel Tower for incredible views of the city..</p>"
                }
              ],
              duration: 1,
              idimagen: 3011,
              startday: 2,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-19",
              enddate: "2022-09-20",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/eiffel-tower-4416700.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/eiffel-tower-4416700.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/eiffel-tower-4416700.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Paris At Leisure or Optional D-Day Beach Experience",
              textday: [
                {
                  textday:
                    "Spend the day soaking up the sights and sounds of this elegant European capital. Your Travel Director will suggest activities and attractions that will ensure a memorable day spent discovering Paris. You may wish to experience a full-day Optional Experience on the northern coast of France to uncover the poignant history of the D-Day Landings. Spend your evening at leisure exploring the city's glittering sights at night."
                }
              ],
              duration: 1,
              idimagen: 20514,
              startday: 3,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-20",
              enddate: "2022-09-21",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/river-shuttle.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/river-shuttle.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/river-shuttle.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                },
                {
                  mealsday: "Dinner"
                }
              ],
              title:
                "Full-Day Excursion to the Palace and Royal Estate of Versailles",
              textday: [
                {
                  textday:
                    "<p>Tread in the footsteps of French nobility and explore the opulence and splendour of Versailles. Join a Local Specialist who will guide you through the palace's extraordinary Hall of Mirrors and Battles Gallery. Stroll through the picturesque Royal Gardens and visit the Petit Trianon to see first-hand how the French Royal Family lived in private, before discovering Marie Antoinette's Hamlet. Return to Paris later for an evening at leisure.</p>"
                }
              ],
              duration: 1,
              idimagen: 3023,
              startday: 4,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-21",
              enddate: "2022-09-22",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-VER/350x240/versailles-675070.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-VER/1200x725/versailles-675070.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-VER/1600x900/versailles-675070.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                },
                {
                  mealsday: "Lunch"
                }
              ],
              title: "Walking Tour in the Marais and French Cuisine Experience",
              textday: [
                {
                  textday:
                    "Explore the intriguing and beautiful Marais district on a walking tour. See the mansions and courtyards of this delightful corner of Paris. Then, 'Dive Into Culture', savouring the exquisite flavours of French cuisine as you meet a Parisian chef for an unforgettable lunch experience. Delve into local culinary secrets, and delicious flavours and aromas, which you will have an opportunity to create yourself and enjoy afterwards. Spend the rest of the day at leisure. This evening, perhaps connect with the pageantry of a traditional cabaret performance at the world-famous Moulin Rouge."
                }
              ],
              duration: 1,
              idimagen: 3005,
              startday: 5,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-22",
              enddate: "2022-09-23",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/cheese-1772829.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/cheese-1772829.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/cheese-1772829.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Visit Montmartre and the Louvre",
              textday: [
                {
                  textday:
                    "A leisurely start to our morning sees us take a private street trolley car back in time to the colourful hillside \"village\" of Montmartre and home to the picturesque Sacré-Coeur. Join your 'Local Specialist' and 'Dive Into Culture' as we tread in the footsteps of Picasso, Dali and Van Gogh, as you wander through hidden squares, artists' haunts and romantic hideaways. Spend the rest of the day on your own embracing your inner bon vivant, before embarking on a special evening experience at the renowned Louvre museum. Enjoy the quiet atmosphere of the museum during this Small Group Sightseeing tour with your 'Local Specialist'."
                }
              ],
              duration: 1,
              idimagen: 20513,
              startday: 6,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-23",
              enddate: "2022-09-24",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/Sacre-Coeur.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/Sacre-Coeur.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/Sacre-Coeur.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                },
                {
                  mealsday: "Be My Guest"
                }
              ],
              title: "Paris Morning At Leisure and Be My Guest",
              textday: [
                {
                  textday:
                    "<p>Perhaps admire the exquisite collection of modern art in the Centres George Pompidou or enjoy an Optional Experience to the inspirational gardens of Monet at Giverny. This evening, Connect With Locals during a memorable Be My Guest experience and Farewell Dinner at Chez Paul, bringing you back to the Paris of the early 1900s. </p>"
                }
              ],
              duration: 1,
              idimagen: 8602,
              startday: 7,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-24",
              enddate: "2022-09-25",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/FR-PAR-MONT/350x240/Montmartre2.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/FR-PAR-MONT/1200x725/Montmartre2.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/FR-PAR-MONT/1600x900/Montmartre2.jpeg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Au Revoir Paris",
              textday: [
                {
                  textday:
                    "<p>After breakfast, it’s time to bid Paris au revoir as you prepare to return home after a memorable break in one of the world's greatest cities. Find out more about your free airport transfer at trafalgar.com/freetransfers.</p>"
                }
              ],
              duration: 0,
              idimagen: 3012,
              startday: 8,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-25",
              enddate: "2022-09-25",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/restaurant-985650.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/restaurant-985650.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/restaurant-985650.jpg",
              image_duplicated: false
            }
          ],
          toitinerary: "2022-09-25",
          fromitinerary: "2022-09-18",
          sellingregions: [
            {
              id: 244,
              order: 1
            }
          ],
          titleitinerary: "Paris Explorer",
          count_days_nights: {
            days: 8,
            nights: 7
          },
          locations_visited: [
            {
              name: "France"
            }
          ],
          approval_signature: null,
          itinerary_tracking_id: "",
          locations_visited_coo: [
            {
              id:
                "6052946,6052941,6052937,6052932,6052927,6052923,6052919,6052915",
              lat: "48.856614",
              lng: "2.3522219",
              name: "Paris",
              idloc: "52162",
              duration: 7,
              startday: "1,2,3,4,5,6,7,8"
            }
          ],
          itinerary_source_type_text: "ITP"
        },
        {
          days: [
            {
              meals: [
                {
                  mealsday: "Welcome Reception"
                }
              ],
              title: "Arrive Paris (7 Nights)",
              textday: [
                {
                  textday:
                    "Paris is yours to explore on this in-depth City Explorer. Check in to your centrally located hotel and spend the afternoon getting to know your surrounds. Wander through the leafy boulevards and winding lanes of the French capital, stopping for a leisurely café au lait while watching sophisticated Parisians go by. This evening, join your fellow travellers and Travel Director for a quintessentially Parisian Welcome Reception."
                }
              ],
              duration: 1,
              idimagen: 10157,
              startday: 1,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "Le Méridien Etoile",
              line_breaks_number: 0,
              startdate: "2022-09-18",
              enddate: "2022-09-19",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/Paris Street.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/Paris Street.jpeg",
              url_image_1600_900:
                "",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Paris Sightseeing and At Leisure",
              textday: [
                {
                  textday:
                    "<p>Join your Travel Director this morning for a tour of this mesmerising city. View the grand Champs-Élysées, Place de la Concorde and Arc de Triomphe, built by Napoleon in the 19th century. Delve into its hidden squares and secret passages, visiting one of Paris's most historic neighbourhoods and a favourite local haunt that remains a secret to outsiders. Next, you’ll Dive Into Culture at Fragonard Parfumerie for a visit with a certified ‘nose' who will guide you in the creation of your own unique fragrance. Later, you’ll experience a true Parisian highlight. Ascend to the second level of the Eiffel Tower for incredible views of the city..</p>"
                }
              ],
              duration: 1,
              idimagen: 3011,
              startday: 2,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-19",
              enddate: "2022-09-20",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/eiffel-tower-4416700.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/eiffel-tower-4416700.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/eiffel-tower-4416700.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Paris At Leisure or Optional D-Day Beach Experience",
              textday: [
                {
                  textday:
                    "Spend the day soaking up the sights and sounds of this elegant European capital. Your Travel Director will suggest activities and attractions that will ensure a memorable day spent discovering Paris. You may wish to experience a full-day Optional Experience on the northern coast of France to uncover the poignant history of the D-Day Landings. Spend your evening at leisure exploring the city's glittering sights at night."
                }
              ],
              duration: 1,
              idimagen: 20514,
              startday: 3,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-20",
              enddate: "2022-09-21",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/river-shuttle.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/river-shuttle.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/river-shuttle.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                },
                {
                  mealsday: "Dinner"
                }
              ],
              title:
                "Full-Day Excursion to the Palace and Royal Estate of Versailles",
              textday: [
                {
                  textday:
                    "<p>Tread in the footsteps of French nobility and explore the opulence and splendour of Versailles. Join a Local Specialist who will guide you through the palace's extraordinary Hall of Mirrors and Battles Gallery. Stroll through the picturesque Royal Gardens and visit the Petit Trianon to see first-hand how the French Royal Family lived in private, before discovering Marie Antoinette's Hamlet. Return to Paris later for an evening at leisure.</p>"
                }
              ],
              duration: 1,
              idimagen: 3023,
              startday: 4,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-21",
              enddate: "2022-09-22",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-VER/350x240/versailles-675070.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-VER/1200x725/versailles-675070.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-VER/1600x900/versailles-675070.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                },
                {
                  mealsday: "Lunch"
                }
              ],
              title: "Walking Tour in the Marais and French Cuisine Experience",
              textday: [
                {
                  textday:
                    "Explore the intriguing and beautiful Marais district on a walking tour. See the mansions and courtyards of this delightful corner of Paris. Then, 'Dive Into Culture', savouring the exquisite flavours of French cuisine as you meet a Parisian chef for an unforgettable lunch experience. Delve into local culinary secrets, and delicious flavours and aromas, which you will have an opportunity to create yourself and enjoy afterwards. Spend the rest of the day at leisure. This evening, perhaps connect with the pageantry of a traditional cabaret performance at the world-famous Moulin Rouge."
                }
              ],
              duration: 1,
              idimagen: 3005,
              startday: 5,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-22",
              enddate: "2022-09-23",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/cheese-1772829.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/cheese-1772829.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/cheese-1772829.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Visit Montmartre and the Louvre",
              textday: [
                {
                  textday:
                    "A leisurely start to our morning sees us take a private street trolley car back in time to the colourful hillside \"village\" of Montmartre and home to the picturesque Sacré-Coeur. Join your 'Local Specialist' and 'Dive Into Culture' as we tread in the footsteps of Picasso, Dali and Van Gogh, as you wander through hidden squares, artists' haunts and romantic hideaways. Spend the rest of the day on your own embracing your inner bon vivant, before embarking on a special evening experience at the renowned Louvre museum. Enjoy the quiet atmosphere of the museum during this Small Group Sightseeing tour with your 'Local Specialist'."
                }
              ],
              duration: 1,
              idimagen: 20513,
              startday: 6,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-23",
              enddate: "2022-09-24",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/Sacre-Coeur.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/Sacre-Coeur.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/Sacre-Coeur.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                },
                {
                  mealsday: "Be My Guest"
                }
              ],
              title: "Paris Morning At Leisure and Be My Guest",
              textday: [
                {
                  textday:
                    "<p>Perhaps admire the exquisite collection of modern art in the Centres George Pompidou or enjoy an Optional Experience to the inspirational gardens of Monet at Giverny. This evening, Connect With Locals during a memorable Be My Guest experience and Farewell Dinner at Chez Paul, bringing you back to the Paris of the early 1900s. </p>"
                }
              ],
              duration: 1,
              idimagen: 8602,
              startday: 7,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-24",
              enddate: "2022-09-25",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/FR-PAR-MONT/350x240/Montmartre2.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/FR-PAR-MONT/1200x725/Montmartre2.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/FR-PAR-MONT/1600x900/Montmartre2.jpeg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Au Revoir Paris",
              textday: [
                {
                  textday:
                    "<p>After breakfast, it’s time to bid Paris au revoir as you prepare to return home after a memorable break in one of the world's greatest cities. Find out more about your free airport transfer at trafalgar.com/freetransfers.</p>"
                }
              ],
              duration: 0,
              idimagen: 3012,
              startday: 8,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-25",
              enddate: "2022-09-25",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/restaurant-985650.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/restaurant-985650.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/restaurant-985650.jpg",
              image_duplicated: false
            }
          ],
          toitinerary: "2022-09-25",
          fromitinerary: "2022-09-18",
          sellingregions: [
            {
              id: 244,
              order: 1
            }
          ],
          titleitinerary: "Paris Explorer",
          count_days_nights: {
            days: 8,
            nights: 7
          },
          locations_visited: [
            {
              name: "France"
            }
          ],
          approval_signature: null,
          itinerary_tracking_id: "",
          locations_visited_coo: [
            {
              id:
                "6052983,6052978,6052974,6052969,6052964,6052960,6052956,6052952",
              lat: "48.856614",
              lng: "2.3522219",
              name: "Paris",
              idloc: "52162",
              duration: 7,
              startday: "1,2,3,4,5,6,7,8"
            }
          ],
          itinerary_source_type_text: "ITP-FLYER"
        },
        {
          days: [
            {
              meals: [
                {
                  mealsday: "Welcome Reception"
                }
              ],
              title: "Arrive Paris (7 Nights)",
              textday: [
                {
                  textday:
                    "Paris is yours to explore on this in-depth City Explorer. Check in to your centrally located hotel and spend the afternoon getting to know your surrounds. Wander through the leafy boulevards and winding lanes of the French capital, stopping for a leisurely café au lait while watching sophisticated Parisians go by. This evening, join your fellow travellers and Travel Director for a quintessentially Parisian Welcome Reception."
                }
              ],
              duration: 1,
              idimagen: 10157,
              startday: 1,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "Le Méridien Etoile",
              line_breaks_number: 0,
              startdate: "2022-09-18",
              enddate: "2022-09-19",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/Paris Street.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/Paris Street.jpeg",
              url_image_1600_900:
                "",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Paris Sightseeing and At Leisure",
              textday: [
                {
                  textday:
                    "<p>Join your Travel Director this morning for a tour of this mesmerising city. View the grand Champs-Élysées, Place de la Concorde and Arc de Triomphe, built by Napoleon in the 19th century. Delve into its hidden squares and secret passages, visiting one of Paris's most historic neighbourhoods and a favourite local haunt that remains a secret to outsiders. Next, you’ll Dive Into Culture at Fragonard Parfumerie for a visit with a certified ‘nose' who will guide you in the creation of your own unique fragrance. Later, you’ll experience a true Parisian highlight. Ascend to the second level of the Eiffel Tower for incredible views of the city..</p>"
                }
              ],
              duration: 1,
              idimagen: 3011,
              startday: 2,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-19",
              enddate: "2022-09-20",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/eiffel-tower-4416700.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/eiffel-tower-4416700.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/eiffel-tower-4416700.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Paris At Leisure or Optional D-Day Beach Experience",
              textday: [
                {
                  textday:
                    "Spend the day soaking up the sights and sounds of this elegant European capital. Your Travel Director will suggest activities and attractions that will ensure a memorable day spent discovering Paris. You may wish to experience a full-day Optional Experience on the northern coast of France to uncover the poignant history of the D-Day Landings. Spend your evening at leisure exploring the city's glittering sights at night."
                }
              ],
              duration: 1,
              idimagen: 20514,
              startday: 3,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-20",
              enddate: "2022-09-21",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/river-shuttle.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/river-shuttle.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/river-shuttle.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                },
                {
                  mealsday: "Dinner"
                }
              ],
              title:
                "Full-Day Excursion to the Palace and Royal Estate of Versailles",
              textday: [
                {
                  textday:
                    "<p>Tread in the footsteps of French nobility and explore the opulence and splendour of Versailles. Join a Local Specialist who will guide you through the palace's extraordinary Hall of Mirrors and Battles Gallery. Stroll through the picturesque Royal Gardens and visit the Petit Trianon to see first-hand how the French Royal Family lived in private, before discovering Marie Antoinette's Hamlet. Return to Paris later for an evening at leisure.</p>"
                }
              ],
              duration: 1,
              idimagen: 3023,
              startday: 4,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-21",
              enddate: "2022-09-22",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-VER/350x240/versailles-675070.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-VER/1200x725/versailles-675070.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-VER/1600x900/versailles-675070.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                },
                {
                  mealsday: "Lunch"
                }
              ],
              title: "Walking Tour in the Marais and French Cuisine Experience",
              textday: [
                {
                  textday:
                    "Explore the intriguing and beautiful Marais district on a walking tour. See the mansions and courtyards of this delightful corner of Paris. Then, 'Dive Into Culture', savouring the exquisite flavours of French cuisine as you meet a Parisian chef for an unforgettable lunch experience. Delve into local culinary secrets, and delicious flavours and aromas, which you will have an opportunity to create yourself and enjoy afterwards. Spend the rest of the day at leisure. This evening, perhaps connect with the pageantry of a traditional cabaret performance at the world-famous Moulin Rouge."
                }
              ],
              duration: 1,
              idimagen: 3005,
              startday: 5,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-22",
              enddate: "2022-09-23",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/cheese-1772829.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/cheese-1772829.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/cheese-1772829.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Visit Montmartre and the Louvre",
              textday: [
                {
                  textday:
                    "A leisurely start to our morning sees us take a private street trolley car back in time to the colourful hillside \"village\" of Montmartre and home to the picturesque Sacré-Coeur. Join your 'Local Specialist' and 'Dive Into Culture' as we tread in the footsteps of Picasso, Dali and Van Gogh, as you wander through hidden squares, artists' haunts and romantic hideaways. Spend the rest of the day on your own embracing your inner bon vivant, before embarking on a special evening experience at the renowned Louvre museum. Enjoy the quiet atmosphere of the museum during this Small Group Sightseeing tour with your 'Local Specialist'."
                }
              ],
              duration: 1,
              idimagen: 20513,
              startday: 6,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-23",
              enddate: "2022-09-24",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/Sacre-Coeur.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/Sacre-Coeur.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/Sacre-Coeur.jpg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                },
                {
                  mealsday: "Be My Guest"
                }
              ],
              title: "Paris Morning At Leisure and Be My Guest",
              textday: [
                {
                  textday:
                    "<p>Perhaps admire the exquisite collection of modern art in the Centres George Pompidou or enjoy an Optional Experience to the inspirational gardens of Monet at Giverny. This evening, Connect With Locals during a memorable Be My Guest experience and Farewell Dinner at Chez Paul, bringing you back to the Paris of the early 1900s. </p>"
                }
              ],
              duration: 1,
              idimagen: 8602,
              startday: 7,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-24",
              enddate: "2022-09-25",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/FR-PAR-MONT/350x240/Montmartre2.jpeg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/FR-PAR-MONT/1200x725/Montmartre2.jpeg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/FR-PAR-MONT/1600x900/Montmartre2.jpeg",
              image_duplicated: false
            },
            {
              meals: [
                {
                  mealsday: "Breakfast"
                }
              ],
              title: "Au Revoir Paris",
              textday: [
                {
                  textday:
                    "<p>After breakfast, it’s time to bid Paris au revoir as you prepare to return home after a memorable break in one of the world's greatest cities. Find out more about your free airport transfer at trafalgar.com/freetransfers.</p>"
                }
              ],
              duration: 0,
              idimagen: 3012,
              startday: 8,
              locations: [
                {
                  code: "FR-PAR",
                  name: "Paris - France",
                  order: 1,
                  location_latitude: 48.856614,
                  location_longitude: 2.3522219
                }
              ],
              accommodation: "",
              line_breaks_number: 0,
              startdate: "2022-09-25",
              enddate: "2022-09-25",
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/350x240/restaurant-985650.jpg",
              url_image_1200_725:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1200x725/restaurant-985650.jpg",
              url_image_1600_900:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1600x900/restaurant-985650.jpg",
              image_duplicated: false
            }
          ],
          toitinerary: "2022-09-25",
          fromitinerary: "2022-09-18",
          sellingregions: [
            {
              id: 244,
              order: 1
            }
          ],
          titleitinerary: "Paris Explorer",
          count_days_nights: {
            days: 8,
            nights: 7
          },
          locations_visited: [
            {
              name: "France"
            }
          ],
          approval_signature: null,
          itinerary_tracking_id: "",
          locations_visited_coo: [
            {
              id:
                "6053020,6053015,6053011,6053006,6053001,6052997,6052993,6052989",
              lat: "48.856614",
              lng: "2.3522219",
              name: "Paris",
              idloc: "52162",
              duration: 7,
              startday: "1,2,3,4,5,6,7,8"
            }
          ],
          itinerary_source_type_text: "ITP-GUEST"
        }
      ],
      client_details: {
        account_name: "YTB Global Travel",
        contact_name: "Cynthia Lyde",
        account_email: "cynthiaanointedtravel@gmail.com"
      },
      departure_date: "2022-09-18",
      selling_regions: [
        {
          id: 244,
          order: 0
        }
      ],
      consumer_section: {
        images: {
          id: 125841,
          background: [],
          cover_page: [
            {
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1300x1738/Eiffel tower Spring - Thinkstock STOCK use by Insight Vacations only.jpeg"
            }
          ],
          cover_video: [],
          images_page: [
            {
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1360x822/restaurant-985650.jpg"
            },
            {
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1360x822/Sacre-Coeur.jpg"
            },
            {
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1360x822/cheese-1772829.jpg"
            },
            {
              url_image:
                "https://dkbr8tla2pux3.cloudfront.net/images/assets/images/FR/FR-PAR/1360x822/arc-de-triomphe-101633.jpg"
            }
          ]
        },
        trip_name: "Wonderful Family Travel",
        highlights: [
          {
            id: 125818,
            items: [
              {
                id: 125819,
                items: "WALKING TOUR of Paris with a Local Specialist"
              },
              {
                id: 125820,
                items:
                  "SMALL GROUP SIGHTSEEING enjoy an in-depth, intimate guided tour of the fascinating Louvre Museum in a group size of no more than 25 guests"
              },
              {
                id: 125821,
                items: "ORIENTATION tour of Paris"
              },
              {
                id: 125822,
                items:
                  "VISIT the Royal Estate of Versailles including the Royal Palace, the Petit Trianon and Marie Antoinette's Hamlet 'Le Petit Hameau' and the 'village' of Montmartre"
              },
              {
                id: 125823,
                items:
                  "VIEW the Eiffel Tower, the Champs Élysées, the Paris Opera House, the Arc de Triomphe, the Place de la Concorde and Notre Dame Cathedral"
              }
            ],
            title: "Sightseeing Highlights"
          }
        ],
        call_action:
          '<p>YTB Global Travel&nbsp;</p><p>Cynthia Lyde - P: (484)297-2859; E: <a href="mailto:cynthiaanointedtravel@gmail.com">cynthiaanointedtravel@gmail.com</a></p>',
        company_name: "YTB Global Travel",
        trip_subtitle: "Trip subtitle",
        whatsincluded: [
          {
            id: 125824,
            items: [
              {
                id: 125825,
                items: "7 breakfasts"
              },
              {
                id: 125826,
                items: "1 lunch"
              },
              {
                id: 125827,
                items: "2 dinners"
              },
              {
                id: 125828,
                items: "1 Parisian Brasserie voucher"
              }
            ],
            title: "Dining Highlights"
          },
          {
            id: 125829,
            items: [
              {
                id: 125830,
                items: "Audio Headsets for flexible sightseeing"
              },
              {
                id: 125831,
                items: "Daily breakfast and up to half your evening meals"
              },
              {
                id: 125832,
                items:
                  "Luxury air-conditioned coach with Wi-Fi in most countries or alternative transportation (such as rail journeys)"
              },
              {
                id: 125833,
                items: "Cherry-picked hotels, all tried and trusted"
              },
              {
                id: 125834,
                items: "Optional Experiences and free time"
              },
              {
                id: 125835,
                items: "All porterage and restaurant gratuities"
              },
              {
                id: 125836,
                items: "Must-see sightseeing and surprise extras"
              },
              {
                id: 125837,
                items: "An expert Travel Director and professional Driver"
              },
              {
                id: 125838,
                items: "All hotel tips, charges and local taxes"
              },
              {
                id: 125839,
                items: "Handcrafted Highlights"
              },
              {
                id: 125840,
                items: "VIP entry to many sights"
              }
            ],
            title: "First class travel Highlights"
          }
        ],
        tour_host_name: "Junior Lopez",
        twinshare_price: "$3,050.00 pp",
        terms_conditions:
          "<p><strong>WHAT'S NOT INCLUDED:</strong> Airfares (unless otherwise stated), passports and applicable visa fees, charges imposed by third parties, laundry, phone calls, items of a personal nature, beverages, meals and sightseeing not detailed on the itinerary, excess baggage, travel insurance. Travel Insurance is highly recommended. Ask your Travel Advisor or Group Specialist for further details.<br><strong>PRICE: </strong>The advertised price is in US dollars, per person twin share.<br><strong>DEPOSIT:</strong> A non-refundable deposit of $200 per person is due at the time of booking. <br><strong>FINAL PAYMENT:</strong> Required 60 days prior to the group's departure date. Final payment due dates are based on trip type or region. See contract or brochure for details.<br><strong>CANCELLATION FEES: </strong>In the event you have to cancel your booking, cancellation fees will apply. For full details of cancellation fees, contact your Travel Advisor or Group Specialist.<br><strong>AMENDMENTS:</strong> Fees may apply to any change made to your booking once confirmed.<br><strong>REFUNDS:</strong> No refund is available if cancellations occur after the trip has commenced or in respect of any sightseeing, accommodation, meals or any other services not utilized.<br><strong>ITINERARY CHANGES & TRIP CANCELLATION:</strong> Prices are based on costs, charges, tariffs, taxes, levies and exchange rates at the time of publication. In the event that such fluctuations affect the price to be paid for services, we reserve the right to adjust the price as necessary at any time. Trafalgar reserves the right to vary itineraries should circumstances dictate, as well as cancel or reschedule any trip departure in accordance with operating requirements, or circumstances beyond its control. The advertised trip requires minimum numbers to depart. Should these not be met, Trafalgar reserves the right to alter or cancel arrangements.<br><strong>PASSPORT AND VISAS:</strong> You must have a valid passport with 6 months validity from date of return. For Visa requirements, contact your Travel Advisor or Group Specialist.<br><strong>HOTELS: </strong>The hotels listed in the itinerary are listed as a guide only and are subject to change.<br><strong>PORTERAGE: </strong>for one suitcase is included in the trip price on arrival and departure from each trip hotel. Refer to https://www.trafalgar.com/en-us/resources/website-terms-of-use for details of luggage allowances.<br><strong>TRANSFERS: </strong>Your Travel Advisor or Group Specialist can provide details of arrival and departure transfers.<br><strong>DOCUMENTATION: </strong>Documentation will be emailed approximately 2 weeks prior to departure.<br><strong>ADDITIONAL TERMS AND CONDITIONS:</strong> apply to this special departure. Full terms and conditions are available from Trafalgar. Refer also to the Trafalgar website at https://www.trafalgar.com/en-us/resources/website-terms-of-use<br><strong>FOR TRAFALGAR SCHEDULED DEPARTURES ONLY</strong><br><strong>DISCOUNTS AND TRAVEL PROTECTION:</strong> You may be able to take advantage of special offers and Travel Protection as detailed in the Trafalgar brochure or website on this trip. Please check with your Travel Advisor or Groups Specialist for applicable discounts. Note: the Travel Protection insurance plan will not cover any additional group discounts or benefits applied to the rest of the group.<br><strong>ROOMING ARRANGEMENTS:</strong> All pricing is based on twin share accommodation. If a single room is required, the appropriate single supplement will need to be paid. Single rooms are subject to availability. Triple rooms may be available on request.</p>",
        short_description:
            "<p>Dear <strong>XXXXX</strong></p>\n\n<p>Welcome to the art of traveling in style. At Insight Vacations we have been creating magical travel experiences for over 40 years, and we are pleased to offer you this proposal for your upcoming Custom Group on the <strong>XXXXX</strong> departing on the<strong> XXXX.</strong></p>\n\n<p><strong>*Additional notes pertaining to the trip here*</strong></p>\n\n<p>As you have exclusive use of the coach, should you wish to make any changes to the itinerary or inclusions, please let us know and we can tailor the trip to the groups desires.</p>\n\n<p><strong>No hotel space has been booked at this stage, therefore hotels listed in this quotation are to be used as a guide only and subject to change depending on availability at time of reservation. Should the quoted hotel be unavailable we will endeavour to book a similar standard property within the quoted budget.</strong></p>\n\n<p>Prices are based on (<strong>firm 2021 </strong>rates/ <strong>OR</strong> <strong>based on 2021 rates to be used as a guide only, therefore quote will be repriced mid year when firm 2022 pricing is released)</strong>. If accommodation dates fall over any conventions or large scale events, or if particular hotel is required to be contracted, a supplement may be applicable. In these cases, we will notify you when this becomes known to discuss options available to your group. Group hotel space works on a first come first served basis, therefore should you wish to proceed with the proposal we encourage you to let us know as soon as possible so we can commence working on hotel reservations! This process can take some time but we will ensure you are kept up to date. Itinerary maybe subject to change also in some extreme cases where, availability is an issue in a localation quoted.</p>\n\n<p>In this new, fast changing COVID-19 era, we have implemented elevated hygiene and distancing practices to meet new requirements put forth by local governments and health authorities, including the World Health Organization (WHO). These details can be found on our website https://www.insightvacations.com/us/the-insight-difference/well-being. As we adapt to this new world we continue to execute numerous new measures throughout our various guest experiences with the best care and service  possible, to ensure optimum health and well-being for our guests and our team. These new protocols will be adapted and adjusted as needed, in a timely manner, as governments define and introduce what will be required in each country.</p>\n\n<p>As these directives become known and if your group is affected, we will work with you to achieve the best outcome keeping the well-being and peace of mind of our guests as our top priority. Considering the fluidity of situation, the pricing and itinerary, including sightseeing venues, hotels and restaurants are subject to change upon government regulatory changes.</p>\n\n<p>Please read the quotation carefully, and full terms and conditions are also provided here for your reference.</p>\n\n<p>Should you wish to proceed, please process a $500 refundable deposit to us and we will in turn commence making reservations for your group.</p>\n\n<p>Please do not hesitate to contact us for any queries you may have, we are here to help! We look forward to the opportunity of working with you.</p>\n\n<p>Kind regards</p>\n\n<p><strong>XXXXX (insert signature with cta here)</strong></p>\n",
        single_supp_price: "$990.00",
        tour_host_position: "Tour host position",
        company_logo: "https://w7.pngwing.com/pngs/221/992/png-transparent-united-states-geological-survey-logo-white-nasa-insignia-earthquake-logo-forbes-angle-white-rectangle-thumbnail.png",
        tour_host_photo: "https://play-lh.googleusercontent.com/I-Yd5tJnxw7Ks8FUhUiFr8I4kohd9phv5sRFHG_-nSX9AAD6Rcy570NBZVFJBKpepmc"
      },
      opportunity_name: "Paris Explorer",
      template_content: null,
      guest_documentation: {
        id: 125855,
        images: {
          id: 125856,
          background: [],
          cover_page: [],
          cover_video: [],
          images_page: []
        },
        hotel_list:
          '<p>Hotel List ---Scheduled --USA-TF</p><div class="table"><table><tbody><tr><td>Name</td><td>Hotel A</td></tr></tbody></table></div>',
        introduction: "",
        optional_experience:
          '<p>We have passionately curated a selection of Optional Experiences to further personalise your trip. These can be booked through your Travel Director/Local Host at the commencement and during your trip. Cash, Visa, Mastercard and American Express are all accepted. Do remember to advise your credit card provider that you will be traveling in Europe/North Africa before you leave home.</p><p>In our new world, as with included sites and venues, owing to new Covid guidelines and restrictions, we could find some of our optional experiences affected with temporary and unexpected closure or amendments and changes to content. Rest assured we will always secure suitable alternatives for choice in your free time and in rare cases we could incur amendments in pricing, rest assured your Travel Director will keep you fully informed at all times.</p><p><i><strong>Input the optional experience list here ↓</strong></i></p><div class="table"><table><tbody><tr><td><strong>Optional Experience Name</strong><br><strong>LOCATION</strong><br>Description<br><strong>Adult Price:</strong> EUR 0.00<br><strong>Child Price:</strong> EUR 0.00<br><strong>Code:</strong> CODE</td></tr><tr><td><strong>Optional Experience Name</strong><br><strong>LOCATION</strong><br>Description<br><strong>Adult Price:</strong> EUR 0.00<br><strong>Child Price:</strong> EUR 0.00<br><strong>Code:</strong> CODE</td></tr><tr><td><strong>Optional Experience Name</strong><br><strong>LOCATION</strong><br>Description<br><strong>Adult Price:</strong> EUR 0.00<br><strong>Child Price:</strong> EUR 0.00<br><strong>Code:</strong> CODE</td></tr><tr><td><strong>Optional Experience Name</strong><br><strong>LOCATION</strong><br>Description<br><strong>Adult Price:</strong> EUR 0.00<br><strong>Child Price:</strong> EUR 0.00<br><strong>Code:</strong> CODE</td></tr></tbody></table></div><p>Many Optional Experiences are operated by independent third party suppliers, not Insight Vacations. Occasionally these experiences involve outdoor activities and/or can be physically demanding. You should make your own decisions about these experiences and only participate in activities that you feel are suited to your own physical ability. We recommend you check that the insurance you have taken out also includes your participation in any activities you may/will undertake during your overall trip. Please Note: Some Optional Experiences may operate on an alternative day to that shown on the itinerary; your Travel Director will confirm full details when you join the trip. Optional Experiences offered are dependent on both the weather and number of participants.</p>'
      },
      properties_opportunity: {
        id: 125811,
        id_brand: 14,
        id_opportunity_status: 5,
        id_opportunity_export_type: 2
      },
      opportunity_details: {
        id_brand: 14,
        departure_date: "2022-09-18"
      },
      created_at: "2021-12-29"
    },
    template: "contiki",
    hash: "PepDs7ZONXgWDTv0bVHnFJ7jKGDJhA3c-eBuf48geGQ"
  }
};
